export { TypeHeroToastProvider, useToast, getToastAPI } from "./toast-context";

export { ToastStack } from "./ToastStack";

export { ToastCard } from "./ToastCard";

import { getToastAPI } from "./toast-context";
import type { ToastAction } from "./types";

export const showSuccessMessage = (
  message: string,
  action?: { label: ToastAction; onClick: () => void },
) => {
  const api = getToastAPI();
  if (api) {
    api.show({ type: "success", title: message, ...(action ? { action } : {}) });
  } else {
    console.warn("[toast-system] Provider not mounted. Message:", message);
  }
};

export const showErrorMessage = (message: string, body?: string) => {
  const api = getToastAPI();
  if (api) {
    api.show({ type: "error-soft", title: message, ...(body ? { body } : {}) });
  } else {
    console.warn("[toast-system] Provider not mounted. Message:", message);
  }
};

export const showWarningMessage = (message: string) => {
  const api = getToastAPI();
  if (api) {
    api.show({ type: "warning", title: message });
  } else {
    console.warn("[toast-system] Provider not mounted. Message:", message);
  }
};

export const showInfoMessage = (message: string) => {
  const api = getToastAPI();
  if (api) {
    api.show({ type: "info", title: message });
  } else {
    console.warn("[toast-system] Provider not mounted. Message:", message);
  }
};
